import { z } from 'zod'

/*
 * Warning shapes the sections render, copied from the retired `/consumer` payloads they
 * were parsed from. The index signature mirrors the source schemas' `.passthrough()`, so
 * payloads keep their extra keys.
 */

export const warningLevelSchema = z.enum(['red', 'yellow', 'green'])

export type ApiWarningLevel = z.infer<typeof warningLevelSchema>

export const warningSourceSchema = z.enum(['vaultV1', 'vaultV2', 'market'])

export type ApiWarningSource = z.infer<typeof warningSourceSchema>

export interface ApiWarningMetadata {
  chainId?: number
  assetAddress?: string
  marketId?: string
  history?: { action: string; timestamp: number }[]
  content?: string | null
  badDebtUsd?: number | null
  badDebtAssets?: string | null
  onChainPrice?: string | null
  expectedPrice?: string | null
  deviationFactor?: number | null
  [key: string]: unknown
}

export interface ApiVaultWarning {
  level: ApiWarningLevel
  type: string
  source?: ApiWarningSource
  metadata?: ApiWarningMetadata | null
  [key: string]: unknown
}

export interface ApiMarketWarning {
  level: ApiWarningLevel
  type: string
  metadata?: ApiWarningMetadata | null
  [key: string]: unknown
}

/** The vault fields the warning aggregators scope `source` against. */
export interface VersionedWarnings {
  version: '1.0' | '1.1' | '2.0'
  warnings: ApiVaultWarning[]
}
